import { useEffect } from "react";
import { useRoute, useLocation } from "wouter";
import { trpc } from "@/lib/trpc";
import { useAuth } from "@/contexts/AuthContext";

// Rota curta compartilhável: /c/:key (content_id ou id) → resolve o cliente,
// troca o cliente ativo e abre o card em /pautas?card=ID. Pedido João jul/26.
export default function ShareRedirect() {
  const [, params] = useRoute("/c/:key");
  const [, navigate] = useLocation();
  const { setActiveClient } = useAuth();
  const key = params?.key ?? "";
  const { data, isLoading, isError } = trpc.pautas.resolveShare.useQuery(
    { key }, { enabled: !!key }
  );

  useEffect(() => {
    if (!key || isLoading) return;
    if (data) {
      setActiveClient(data.clientId);
      navigate(`/pautas?card=${data.id}`);
    } else if (isError || data === null) {
      navigate("/pautas");
    }
  }, [data, isLoading, isError, key]);

  return (
    <div className="h-screen flex items-center justify-center">
      <div className="text-zinc-400 text-sm flex items-center gap-2">
        <div className="w-4 h-4 rounded-full border-2 border-[#E7E5E0] border-t-[#0A0A0A] animate-spin" />
        Abrindo o card…
      </div>
    </div>
  );
}
